export const isDev = import.meta.env.VITE_ENV === 'development';
export const isStg = import.meta.env.VITE_ENV === 'staging';
const isTest = import.meta.env.VITE_ENV === 'test';

// flagの内容
// false: 開発中
// true: リリース
const flags = {
  ANDEV_7180_FOLLOW_LIST_PUBLISHED_AT: false,
  ANDEV_9078_FORCED_IDEATION: true,
  ANDEV_9479_MARKET_SIZING: true,
  ANDEV_10285_FMEA: false,
  ANDEV_9473_TECH_EXP_COMPARISON_SUMMARY: false,
  ANDEV_9579_TECH_EXP_USER_DOCUMENT_GENERATION_POC: false,
  ANDEV_9591_PATENT_FTO_CLAIM_VERIFICATION: true,
  ANDEV_9844_HELP_MENU_RENEWAL: true,
  // ルート定義の新旧はビルド時に vite.config.mts で切り替えているため、値を変えるときはそちらも揃える
  ANDEV_10131_CAPABILITY: false,
  ANDEV_10336_RAISE_SURVEY_PROMPT_LIMIT: true,
  ANDEV_10700_INSIGHT_ADDITIONAL_BUSINESS_CONTEXT: true,
  ANDEV_10813_INSIGHT_ADDITIONAL_BUSINESS_CONTEXT_SUGGESTION: true,
  ANDEV_9869_MARKET_SIZING_PPTX_EXPORT: true,
  ANDEV_10553_ONBOARDING_RENEWAL: false,
  ANDEV_10474_MARKET_SIZING_TOPIC_LENGTH_LIMIT: true,
  ANDEV_10719_INSIGHT_TOPIC_HINT_PAIR: true,
  ANDEV_10753_TECH_EXP_NO_CREDIT: false,
  ANDEV_10543_MARKET_SIZING_CONDITION_EXPANSION: false,
  ANDEV_10765_TECH_EXP_NEW_UX: false,
  ANDEV_10807_INSIGHT_SAMPLE: false,
};

const isKey = (x: string): x is keyof typeof flags => x in flags;
Object.keys(flags).forEach(key => {
  if (!isKey(key)) return;
  flags[key] = isDev || isTest || flags[key];
});

export const featureFlags = flags;
